import styled from 'styled-components';

import {
  SelectIdField,
  RadioButtonField,
  PhoneField,
  TextareaField,
  PrecautionFields,
  UrgencyIdField,
} from '~fields';

const StudyRoomCleanForm = props => {
  const rooms = props.rooms;
  const { room } = props.formik.values;
  const setFieldValue = props.formik.setFieldValue;

  const crimeRoom =
    rooms.find(r => r.id === room)?.clinicalSubUsage === 'SERI_ROOM';

  const roomOptions = rooms.map(room => ({
    label: room.clinicalName,
    value: room.id,
  }));

  // TODO Both produce now URGN, can clean up..
  const handleBeforeAfterChange = value => {
    switch (value) {
      case 'PRE_EXAMMINATION':
        setFieldValue('urgency', 'URGN');
        break;
      default:
        setFieldValue('urgency', 'URGN');
        break;
    }
  };

  const handleSeriChange = value => {
    if(!(rooms.find(r => r.id === value)?.clinicalSubUsage === 'SERI_ROOM'))
      setFieldValue('urgency', 'URGN');
  };

  return (
    <>
      <p>Lomakkeella tilataan äkilliset siivoustarpeet tutkimushuoneisiin.</p>
      <Wrapper>
        <SelectIdField 
          name="room" required 
          options={roomOptions}
          onChange={handleSeriChange}
        />

        {crimeRoom && <RadioButtonField 
          name="cleanupTime"
          onChange={handleBeforeAfterChange}
        />}

        <UrgencyIdField name="urgency" required />
        <PrecautionFields {...props} />
        <PhoneField name="contactPhone" />
        <TextareaField name="additionalInfo" />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
`;

export default StudyRoomCleanForm;
